/**
 * @module FAQ Item
 * @description
 */
import { useState } from "react";
import classNames from "classnames/bind";
import styles from "./index.module.css";
import { injectLegalAndTooltips } from "@/js/utils/legal";

const cx = classNames.bind(styles);

/**
 * @function Component
 * @description
 */
const Component = ({ id, title, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = (e) => {
    setIsExpanded(!isExpanded);
    // Custom event used by the FAQs Chat trigger
    e.currentTarget.dispatchEvent(
      new CustomEvent("faq-clicked", {
        bubbles: true,
      }),
    );
  };

  // Conditionally set active classnames
  const iconClassName = cx({
    "icon-chevron-down1": true,
    icon: true, // always load icon styles
    isExpanded, // Load isExpanded based on bool
  });

  const buttonClassName = cx({
    button: true,
    h6: true,
    borderBottom: !isExpanded,
  });

  return (
    <>
      <h3 className="h6">
        <button
          id={`${id}-header`}
          aria-controls={`${id}-panel`}
          aria-expanded={isExpanded}
          onClick={handleClick}
          className={buttonClassName}
        >
          {title}
          <span className={iconClassName} />
        </button>
      </h3>

      <section
        className={`${styles.borderBottom} ${styles.item}`}
        id={`${id}-panel`}
        aria-labelledby={`${id}-header`}
        hidden={!isExpanded}
      >
        <p>
          {typeof children === "string"
            ? injectLegalAndTooltips(children)
            : children}
        </p>
      </section>
    </>
  );
};

export default Component;
